import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Module from './Module';

const List = ({ userRole, data, onSelect, onToggle }) => (
    <>
        <div className="d-flex py-2">
            <div className="d-flex-6 dsl-m12">Courses</div>
            <div className="d-flex-1 dsl-m12">Tracks</div>
            <div className="d-flex-1 dsl-m12">Courses</div>
            <div className="d-flex-1 dsl-m12">Assigned</div>
        </div>
        {data.map((item, index) => (
            <Module
                key={`${item.id}-${index}`}
                userRole={userRole}
                name={item?.data?.en?.name || ''}
                description={item.data.en?.description || ''}
                type={item.card_type_id}
                thumbnail={item.data.thumb_url}
                assigned={item.data.assigned}
                tracks={item.data.tracks_count}
                courses={item.data.courses_count}
                published={item.published}
                onDetail={() => onToggle(item.id, 'view')}
                onPreview={() => onSelect('preview view', item)}
                onSelect={(e) => onSelect(e, item)}
            />
        ))}
    </>
);

List.propTypes = {
    userRole: PropTypes.number,
    data: PropTypes.array,
    onToggle: PropTypes.func,
};

List.defaultProps = {
    userRole: 1,
    data: [],
    onToggle: () => {},
};

export default memo(List);
